import React from "react";
import SubtitleAndDescription from "../../Common/SubtitleAndDescription";
import { EXPANSION, SEASON } from "../../../lib/wowHelpers";
import { Duration } from "luxon";

const MythicPlusActivity = ({ keys }) => {
  if (keys.length <= 0) return null;

  // Sometimes, the data is returning multiples of the same dungeon - this retrieves the unique list of dungeons
  // with the highest ratings
  let uniqueDungeons = {};
  keys.forEach((key) => {
    if (!uniqueDungeons[key.dungeon] || key.rating > uniqueDungeons[key.dungeon].rating) {
      uniqueDungeons[key.dungeon] = key;
    }
  });
  const highestRatedKeys = Object.values(uniqueDungeons);

  return (
    <div className="mythic-plus-activity-container">
      <SubtitleAndDescription
        subtitle="Mythic Keystone Dungeons Seasonal Activity"
        description={`${EXPANSION} Season ${SEASON}`}
      />
      <div className="key-activity-boxes-container">
        {highestRatedKeys.map((keyData, index) => (
          <ActivityBox keyData={keyData} key={index} />
        ))}
      </div>
    </div>
  );
};

const ActivityBox = ({ keyData }) => {
  const dungeonImages = {
    "The Vortex Pinnacle": "vortex_pinnacle",
    "Uldaman: Legacy of Tyr": "uldaman",
    "Halls of Infusion": "halls_of_infusion",
    "Brackenhide Hollow": "brackenhide_hollow",
    Neltharus: "neltharus",
    Freehold: "freehold",
    "The Underrot": "underrot",
    "Neltharion's Lair": "neltharions_lair",
    "Atal'Dazar": "AtalDazar",
    "Black Rook Hold": "BlackRookHold",
    "Darkheart Thicket": "DarkheartThicket",
    "The Everbloom": "Everbloom",
    "Dawn of the Infinite: Galakrond's Fall": "GalakrondsFall",
    "Dawn of the Infinite: Murozond's Rise": "MurozondsRise",
    "Throne of the Tides": "ThroneOfTheTides",
    "Waycrest Manor": "WaycrestManor",
  };

  const backgroundImg = dungeonImages[keyData.dungeon]
    ? `https://static.bigbrain.gg/wow/mythic-plus/${dungeonImages[keyData.dungeon]}.png`
    : "";

  const getDungeonName = (dungeon) => {
    const dungeonSplit = dungeon.split(": ");
    if (dungeonSplit.length > 1) return dungeonSplit[1];
    return dungeonSplit[0];
  };

  return (
    <div
      className="activity-box"
      style={{ backgroundImage: `linear-gradient(180deg, rgba(23, 23, 86, 0.31) 0%, #191937 100%), url(${backgroundImg})` }}
    >
      <div className="key-container">
        <img src="https://static.bigbrain.gg/wow/mythic-plus/key_icon.png" className="key-icon" />
        <div className="key">{keyData.key}</div>
      </div>
      <div className="dungeon-and-duration-container">
        <div className="dungeon">{getDungeonName(keyData.dungeon)}</div>
        <div className="duration">{Duration.fromMillis(keyData.duration).toFormat("hh:mm:ss")}</div>
      </div>
      <div className="rating-container">
        <div className="rating">{Math.round(keyData.rating).toLocaleString("en-US")}</div>
        <div className="rating-label">Rating</div>
      </div>
    </div>
  );
};

export default MythicPlusActivity;
